<template>
    <div>
        <template
            v-if="mobile"
        >
            <summary-value
                class="py-3 px-4"
                :small="small"
                no-description
            >
                <template v-slot:label>
                    LPP™ {{ chosen }}
                </template>
                <template v-slot:value>
                    {{ getLppLabel(client.lpp_type) }}
                </template>
                <template v-slot:description>
                    <v-tooltip
                        bottom
                        v-if="checkNested(benefits, 'selectedLpp', 'description')"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="grey lighten-1"
                                small
                            >
                                $mdiInformation
                            </v-icon>
                        </template>
                        <span v-html="benefits.selectedLpp.description"/>
                    </v-tooltip>
                </template>
            </summary-value>

            <v-divider></v-divider>

            <summary-value
                class="py-3 px-4"
                :object="benefits"
                property="lppMonthlyPremium"
                :small="small"
            ></summary-value>

            <!--            <template-->
            <!--                v-if="showShortfallPercentage"-->
            <!--            >-->
            <!--                <v-divider></v-divider>-->

            <!--                <summary-breakdown-->
            <!--                    color="red"-->
            <!--                    class="pb-3 px-4"-->
            <!--                    :object="benefits"-->
            <!--                    :property="shortFall"-->
            <!--                    :small="small"-->
            <!--                ></summary-breakdown>-->
            <!--            </template>-->
        </template>
        <template v-else>
            <template
                v-for="(property, index) in properties_object"
            >
                <v-divider
                    v-if="index !== 0"
                    class="mx-4"
                ></v-divider>

                <summary-breakdown
                    class="py-3 px-4"
                    :object="benefits"
                    :property="property"
                    :key="'property-' + index"
                    :small="small"
                ></summary-breakdown>
            </template>

            <!--            <template-->
            <!--                v-if="showShortfallPercentage"-->
            <!--            >-->
            <!--                <summary-breakdown-->
            <!--                    color="red"-->
            <!--                    class="pb-3 px-4"-->
            <!--                    :object="benefits"-->
            <!--                    :property="shortFall"-->
            <!--                    :small="small"-->
            <!--                    no-description-->
            <!--                ></summary-breakdown>-->
            <!--            </template>-->

            <v-divider
                class="mx-4"
            ></v-divider>

            <summary-value
                class="py-3 px-4"
                :small="small"
                no-description
            >
                <template v-slot:label>
                    LPP™ {{ chosen }}
                </template>
                <template v-slot:value>
                    {{ getLppLabel(client.lpp_type) }}
                </template>

                <template v-slot:description>
                    <v-tooltip
                        bottom
                        v-if="checkNested(benefits, 'selectedLpp', 'description')"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="grey lighten-1"
                                small
                            >
                                $mdiInformation
                            </v-icon>
                        </template>
                        <span v-html="benefits.selectedLpp.description"/>
                    </v-tooltip>
                </template>
            </summary-value>

            <v-divider></v-divider>

            <template
                v-for="(property, index) in properties"
            >
                <summary-value
                    :key="index"
                    class="py-3 px-4"
                    :object="benefits"
                    :property="property"
                    :small="small"
                    :greyed="isGreyed(property)"
                    :inverted="isInverted(property)"
                ></summary-value>

                <v-divider></v-divider>
            </template>
        </template>
    </div>
</template>

<script>
    import SummaryValue from "../../../Global/SummaryValue";
    import SummaryBreakdown from "../../../Global/SummaryBreakdown";

    import MyCoverMixin from "../../mycover";

    export default {
        name: 'My-Cover-Summary-Estate',

        components: {
            SummaryValue,
            SummaryBreakdown
        },

        mixins: [
            MyCoverMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            },
            'small': {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            chosen() {
                return this.benefits_requested && this.client.lpp_type === this.benefits.recommendedLpp.value ? 'Recommended' : 'Selection';
            },
            showShortfallPercentage() {
                return this.benefits_requested && typeof this.benefits.productIndemnificationShortfallPercentage !== 'undefined' && this.benefits.productIndemnificationShortfallPercentage.value > 0;
            },
            shortFall() {
                return {
                    'label': '',
                    'values': [
                        'productIndemnificationShortfallPercentage'
                    ]
                };
            },
            properties_object() {
                let objects = [
                    {
                        'label': 'Estate & Executor Fees',
                        'values': [
                            'estateValue',
                            'executorFeesOnEstate'
                        ]
                    },
                    {
                        'label': 'Property & Transfer Fees',
                        'values': [
                            'propertiesValues',
                            'conveyanceCost'
                        ]
                    },
                    {
                        'label': 'Trust & Trustees Fees',
                        'values': [
                            'valueToTrust',
                            'trusteeFeesExcludingMyCover'
                        ]
                    }
                ];

                let totalFees = [
                    'totalFeesRequiringIndemnification'
                ];

                if (this.client.value !== 0) {
                    totalFees.push('productIndemnificationCoveragePercentage');
                }

                objects.push(
                    {
                        'label': 'Total Estate Fees',
                        'values': totalFees
                    }
                );


                return objects;
            }

        },

        data() {
            return {
                properties: [
                    'productMaximumIndemnity',
                    'lppBenefits',
                    'lppMonthlyPremium'
                ]
            }
        },

        methods: {
            isGreyed(property) {
                return property === 'lppBenefits' || property === 'productMaximumIndemnity';
            },
            isInverted(property) {
                return property === 'lppMonthlyPremium';
            }
        }
    }
</script>
